<template>
  <!-- <ExploreMap class="map-wrapper" v-slot="{isMapActive, toggleMapView}"> -->
  <AmexDiningDetails
    @show-details="onShowPoiDetailsFromMap"
    @item-selected="onHotelComplete"
    :category="stayCategory"
    :isSplashVisible="isSplashVisible"
    :selectedDay="selectedDate"
  >
    <template v-slot:header>
      <AmexDetailsHeader class="details-header" :items="headerIcons" @change-view="onSelectDetailsView" ref="splash">
        <!-- <li class="search-wrapper">
          <button class="btn-clear nav-link find-places-btn">
            <SearchIcon />
            <span>Find Places</span>
            <div class="search">
              <AmexSearchInput
                placeholder="Type a Hotel, Restaurant or Place.."
                :isIconVisible="false"
                class="search-input"
                :value="searchInputValue"
                @input="onSearchInputChangeEv"
              />
              <div class="search-section-wrapper" v-if="searchOptions.length || filterOptions.length">
                <span class="title">Places</span>
                <AmexDropdown :active="searchOptions.length > 0" class="dropdown">
                  <ExpItem
                    v-for="item in searchOptions"
                    :key="item.id"
                    :activity="item"
                    :isRemoveAllowed="false"
                    class="select-option"
                    @click="onSelectSearchPoi(item)"
                  />
                </AmexDropdown>
              </div>
              <div class="search-section-wrapper" v-if="filterOptions.length">
                <span class="title">Filters</span>
                <AmexDropdown :active="filterOptions.length > 0" class="dropdown">
                  <InterestDropItem
                    @click="toggleTag(item)"
                    :value="item.parent"
                    :label="item.text"
                    :tag="item"
                    class="select-option"
                    v-for="item in filterOptions"
                    :key="item.id"
                  />
                </AmexDropdown>
              </div>
            </div>
          </button>

        </li> -->
      </AmexDetailsHeader>
    </template>
    <h1 class="page-geader">Explore Places to Stay</h1>
    <template v-slot:splash>
      <StayAddedSplash
        :img="addedStayImg"
        text="You've added a Stay!"
        :name="addedStayName"
        @get-started="onExperiencesOpen"
        @curate-trip="onHideSplash"
      />
    </template>
    <template v-slot:selected-item>
      <div class="selected-stay" v-if="stay && isStaysOn">
        <div class="picture-wrapper">
          <div class="parent">
            <div class="img-container">
              <div class="img slider-overflow" :style="{backgroundImage: `url('${backgroundImage}')`}"></div>
            </div>
          </div>
        </div>
        <div class="stay-details">
          <div class="stay-name">{{ stay.name }}</div>
          <div class="stay-hint">
            {{ bookingDisclaimer }}
          </div>
          <div class="rating-wrapper">
            <StarRating class="star-rating" :rating="stay.rating" read-only :star-size="12" :increment="0.1" />
          </div>
        </div>

        <div class="stay-price">
          <span class="price" :class="{bookable: stay.bookingUrl}">
            <span class="price-label">Per night/</span>
            <span class="price-label">all rooms</span>
            {{ stay && stay.price }}
          </span>
        </div>

        <div class="stay-book">
          <a
            v-if="stay.bookingUrl"
            :href="stay.bookingUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="core-button"
            @mousedown="redirectToActivity($event)"
          >
            <span>Book</span>
            <ExtLinkIcon class="icon-external-link icon-external-link--white"></ExtLinkIcon>
          </a>
          <a v-else :href="stay.webURL" target="_blank" rel="noopener noreferrer" class="core-button">
            <span>Details</span>
            <ExtLinkIcon class="icon-external-link"></ExtLinkIcon>
          </a>
        </div>
      </div>
    </template>
  </AmexDiningDetails>
  <!-- </ExploreMap> -->
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {computed, defineComponent, ref} from '@vue/composition-api';
import {AmexSearchInput, AmexDropdown, InterestDropItem} from '@mobi-components/amex-bluesky-components';
import {useCommonFind} from '../../solution-views/explore-view/common-find';
import {useSolutionViews} from '../../solution-views/solution-views';
import AmexDiningDetails from '../../solution-views/explore-view/solution-dining-details-content.vue';
import StayAddedSplash from './stay-added-splash/stay-added-splash.vue';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import ExploreMap from '../explore-map/explore-map.vue';
import {useRouter} from '@/router';
import {ToggleComponent} from '@mobi-components/toggle';
import '@mobi-components/toggle/dist/toggle.css';
import SearchIcon from '../../svg/search.vue';
import {useStay} from '../../solution-views/stay';
import StarRating from 'vue-star-rating';
import ExpItem from '../../explore-page/exp-list/exp-item.vue';
import {getUserId} from '@/services/auth-shared';
import {trackBtnClick} from '@/store/api/trackBtnClick';
import {openDynamicUrl} from '../../summary-page/useSaveSolutionDialod';
import {loadRecommendationDetails} from '@/store/state/helpers';
import {ProblmSubmissionRoute} from '@/store/state/global.types';
import AmexDetailsHeader from '../details-header.vue';
import ExtLinkIcon from '@components/svg/external-link.vue';
Vue.use(VueCompositionAPI);

export default defineComponent({
  components: {
    AmexDetailsHeader,
    AmexDiningDetails,
    StayAddedSplash,
    ExploreMap,
    ToggleComponent,
    SearchIcon,
    AmexSearchInput,
    AmexDropdown,
    ExpItem,
    StarRating,
    InterestDropItem,
    ExtLinkIcon,
  },
  setup(_, {root}) {
    const selectedDate = computed(() => {
      const router = useRouter();
      const date = parseInt(router.currentRoute.query?.date || 0, 10);
      return date;
    });

    const splash = ref(null);

    const addedStayName = ref('');
    const addedStayImg = ref('');
    const onHideSplash = () => {
      addedStayImg.value = '';
      addedStayName.value = '';
    };

    const onHotelComplete = (poi) => {
      addedStayImg.value = poi?.images?.medium || '';
      addedStayName.value = poi?.name || '';
      if (splash.value?.$el) {
        root.$nextTick(() => {
          splash.value.$el.scrollIntoView();
        });
      }
    };

    const isSplashVisible = computed(() => {
      return Boolean(addedStayName.value);
    });

    // prettier-ignore
    const {backToSummaryView, headerIcons, onSelectDetailsView, onExperiencesOpen, onShowPoiDetailsFromMap, isStaysOn} =
      useSolutionViews(root);

    const {stay} = useStay();

    const backgroundImage = computed(() => {
      return stay.value?.img || '';
    });

    const category = ref(UserActivityCategoryEnum.ACCOMMODATION);
    const trackBooking = () => {
      const userId = getUserId();
      trackBtnClick(userId, stay.value.bookingUrl);
    };

    const redirectToActivity = (e) => {
      e.preventDefault();
      trackBooking();
      openDynamicUrl(stay.value.bookingUrl);
    };

    const loadAdditionalExperiences = async () => {
      await loadRecommendationDetails(ProblmSubmissionRoute.SOLUTION);
      return null;
    };

    return {
      headerIcons,
      onSelectDetailsView,
      backToSummaryView,
      stayCategory: UserActivityCategoryEnum.ACCOMMODATION,
      isSplashVisible,
      onHotelComplete,
      addedStayImg,
      splash,
      addedStayName,
      onHideSplash,
      onExperiencesOpen,
      onShowPoiDetailsFromMap,
      selectedDate,
      ...useCommonFind(category, onShowPoiDetailsFromMap, loadAdditionalExperiences),
      stay,
      backgroundImage,
      trackBooking,
      isStaysOn,
      redirectToActivity,
      bookingDisclaimer:
        process.env.VUE_APP_BOOKING_DISCLAIMER ||
        'Once you’re ready to book, you’ll be redirected to AmexTravel.com where you can enjoy any travel benefits associated with your Card and, if eligible, use Membership Rewards® points at checkout.',
    };
  },
});
</script>

<style lang="sass" scoped>
@import '../btn-trip-summary.scss'
@import '../../solution-views/explore-view/common-explore-view.scss'
</style>
<style lang="scss" scoped>
.selected-stay {
  background: #ffffff;
  box-shadow: 0px 0px 25px rgb(0 0 0 / 10%);
  border-radius: 7px;
  padding: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
}

.picture-wrapper {
  position: relative;
  width: 70px;
  height: 70px;
}

.parent {
  width: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.img-container {
  display: block;
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  padding: 100% 0 0 0;
  border-radius: 4px;
}

.img-container::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.img-container .img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-size: cover;
  background-position: center;
}

.stay-details {
  margin-left: 20px;
  position: relative;
  top: -7px;
}

.stay-details .stay-name {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 118.14%;
  /* or 21px */

  letter-spacing: -0.005em;

  color: #071d3b;
}

.stay-hint {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 118.14%;
  /* identical to box height, or 19px */

  letter-spacing: -0.005em;

  color: rgba(7, 29, 59, 0.67);
  margin-bottom: 5px;
}

.rating-wrapper {
  position: relative;
  float: left;
  width: 0;
}

.star-rating {
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.2s ease-in-out;
}

.stay-price {
  margin-left: auto;
}

.price {
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 118.14%;
  text-align: right;
  letter-spacing: -0.005em;
  color: #071d3b;
  padding: 10px;
}

.price.bookable {
  border-right: 1px solid #f1f1f1;
}

.price-label {
  display: block;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 118.14%;
  text-align: right;
  letter-spacing: -0.005em;
  color: rgba(7, 29, 59, 0.37);
  white-space: nowrap;
}

.stay-book {
  margin-left: 20px;
}

.stay-book > a {
  color: var(--toneBw-0);
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.core-button {
  --core-btn-bg-color: var(--btn-primary-color, hsl(208, 100%, 41%));
  --core-btn-border: var(--btn-primary-color, hsl(208, 100%, 41%));
  --core-btn-color: #fff;
  height: 40px;
  line-height: 41px;
  color: var(--core-btn-color);
  text-decoration: none !important;
  border-radius: 10px;
  padding: 0 60px;
  background-color: var(--core-btn-bg-color);
  border: 1px solid var(--core-btn-border);
  font-size: 16px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
.icon-external-link {
  color: var(--btn-grayed-f-color);
  height: 14px;
  width: 10px;
  margin-left: 10px;
  margin-bottom: -2px;
  &--white {
    color: white;
  }
}
</style>
